class ImageComparison extends HTMLElement {
  #isDragging = false;
  #position = 50;

  connectedCallback() {
    this.#updatePosition(50);

    this.addEventListener('mousedown', this.#onPointerDown);
    this.addEventListener('touchstart', this.#onPointerDown, { passive: false });

    const button = this.querySelector('.image-comparison__handle-button');
    if (button) {
      button.addEventListener('keydown', this.#onKeyDown);
    }
  }

  #onPointerDown = (e) => {
    // Ignore right-click
    if (e.button && e.button !== 0) return;

    this.#isDragging = true;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    this.#updateFromClientX(clientX);

    if (e.type === 'touchstart') {
      e.preventDefault();
    }

    const onMove = (e) => {
      if (!this.#isDragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      requestAnimationFrame(() => this.#updateFromClientX(clientX));
    };

    const onUp = () => {
      this.#isDragging = false;
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onUp);
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    document.addEventListener('touchmove', onMove, { passive: true });
    document.addEventListener('touchend', onUp);
  };

  #onKeyDown = (e) => {
    const step = 2;
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      this.#updatePosition(Math.max(0, this.#position - step));
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      this.#updatePosition(Math.min(100, this.#position + step));
    }
  };

  #updateFromClientX(clientX) {
    const rect = this.getBoundingClientRect();
    const position = ((clientX - rect.left) / rect.width) * 100;
    this.#updatePosition(Math.max(0, Math.min(100, position)));
  }

  #updatePosition(position) {
    this.#position = position;
    this.style.setProperty('--position', `${position}%`);
  }
}

if (!customElements.get('image-comparison')) {
  customElements.define('image-comparison', ImageComparison);
}
